module.exports = __webpack_public_path__ + "img/2023第二届烽火杯目标智能识别大赛.f4816cc3.jpg";